var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgSendToVerifier(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.019,
    height: 22.293,
    viewBox: "0 0 22.019 22.293"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-send-to-verifier_svg__cls-1{fill:none}.kpmg-send-to-verifier_svg__cls-4{fill:#1fb4ff}.kpmg-send-to-verifier_svg__cls-3,.kpmg-send-to-verifier_svg__cls-4{stroke:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-send-to-verifier_svg__ICN_Trimite_la_Verificare_Enabled",
    "data-name": "ICN_Trimite la Verificare_Enabled",
    transform: "translate(-187.075 -257.871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-send-to-verifier_svg__Path_969",
    "data-name": "Path 969",
    className: "kpmg-send-to-verifier_svg__cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "kpmg-send-to-verifier_svg__cls-3",
    d: "M6.5 4.678c.217-1.957 1.876-2.705 3.162-.721l6.655 10c1.049 1.559.635 2.252-.752 2.806l-9.53 4.395c-1.1.419-2.3-.831-1.969-2.111z",
    transform: "rotate(43 -221.947 378.671)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kpmg-send-to-verifier_svg__cls-4",
    d: "M8.145 4.583c-.02.075-.039.165-.05.27l-.006.047-.007.045-2.439 14.37-.011.066-.017.066a.19.19 0 00.02.133l9.265-4.267.038-.018.039-.015c.087-.035.16-.067.22-.095a4.01 4.01 0 00-.203-.332l-.002-.003-.003-.004L8.334 4.842l-.005-.008-.005-.007c-.065-.1-.125-.18-.179-.244M8.022 2.79c.527 0 1.117.354 1.644 1.167l6.656 10.004c1.048 1.56.634 2.252-.752 2.806l-9.535 4.392a1.239 1.239 0 01-.445.082c-.948 0-1.81-1.085-1.524-2.194L6.504 4.678c.128-1.155.758-1.89 1.518-1.89z",
    transform: "rotate(43 -221.947 378.671)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-send-to-verifier_svg__Path_971",
    "data-name": "Path 971",
    d: "M4.778 8.321c.028-.966 1.051-1.583 1.426-.1 0 0 1.007 4.562 1.18 5.4l-2.438 1.86c-.32.313-1.017.379-.92-.575z",
    transform: "rotate(43 -228.468 382.1)",
    fill: "#1fb4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-send-to-verifier_svg__Path_970",
    "data-name": "Path 970",
    className: "kpmg-send-to-verifier_svg__cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "kpmg-send-to-verifier_svg__cls-3",
    d: "M5.458 4.8c.217-1.026 1.379-1.692 2.665-.652l2.1 2.274c1.049.817.635 1.181-.752 1.471l-3.792.66c-1.1.22-.872-.2-.542-.867z",
    transform: "rotate(-148 139.217 113.929)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "kpmg-send-to-verifier_svg__cls-4",
    d: "M7.01 5.312l-.157 1.411 1.266-.22-1.079-1.17a1.236 1.236 0 00-.03-.02m-.17-1.689c.387 0 .827.155 1.283.523l2.097 2.274c1.049.817.635 1.18-.752 1.47l-3.791.661c-.201.04-.358.06-.477.06-.535 0-.335-.378-.065-.926l.323-2.887c.14-.662.674-1.175 1.381-1.175z",
    transform: "rotate(-148 139.217 113.929)"
  })))));
}

export default SvgKpmgSendToVerifier;